const reducers = {
    shippingAddress(state, action) {
      state.address.shippingAddress = action.payload.shippingAddress;
    },
    billingAddress(state, action) {
      state.address.billingAddress = action.payload.billingAddress;
    },
    showShippingError(state, action) {
      state.address.showShippingError = action.payload.showShippingError;
    },
    shippingError(state, action) {
      state.address.shippingError = action.payload.shippingError;
    },
    shippingBillingAgreement(state, action) {
      state.address.shippingBillingAgreement = action.payload.flag;
    },
    setCustomerVersion(state, action) {
      state.address.customerVersion = action.payload.customerVersion;
    },
    setCurrentSelectedCountry(state, action) {
      state.address.currentSelectedCountry = action.payload.country;
    },
    setTaxRateActions(state, action) {
      state.address.taxActions = [...action.payload.taxActions];
    },
    setOldVatId(state, action) {
      state.address.oldVatId = action.payload.oldVatId;
    },
    setOldVatCountry(state, action) {
      state.address.oldVatCountry = action.payload.oldVatCountry;
    },
    setVatStatus(state, action) {
      state.address.vatStatus = action.payload.vatStatus;
    },
    setOldVat(state, action) {
      state.address.oldVat = action.payload.oldVat;
    },
    setOldUsbVat(state, action) {
      state.address.oldUsbVat = action.payload.oldUsbVat;
    },
    setUpdateVatMsg(state, action) {
      state.address.vatUpdateMsg = action.payload.updatedMsg;
    },
    setShipAddressModified(state, action) {
      state.address.shipAddressModified = action.payload.shipAddressModified;
    },
    setBillAddressModified(state, action) {
      state.address.billAddressModified = action.payload.billAddressModified;
    },
    setIsManualShippingAddress(state, action) {
      state.address.isManualShippingAddress = action.payload.isManualShippingAddress;
    },
    setIsManualBillingAddress(state, action) {
      state.address.isManualBillingAddress = action.payload.isManualBillingAddress;
    },
    setDefaultShippingAddress(state, action) {
      state.address.defaultShippingAddress = action.payload.defaultShippingAddress;
    },
    setDefaultBillingAddress(state, action) {
      state.address.defaultBillingAddress = action.payload.defaultBillingAddress;
    },
    setIsValidEmail(state, action) {
      state.address.isValidEmail = action.payload.isValidEmail;
    },
    setIsPostalCodeBlur(state, action) {
      state.address.isPostalCodeBlur = action.payload.isPostalCodeBlur;
    },
    setValidatedEmail(state, action) {
      state.address.validatedEmail = action.payload.validatedEmail;
    },
    setMoveToPaymentPage(state, action) {
      state.address.moveToPaymentPage = action.payload.moveToPaymentPage;
    },
    setLoqateEnabled(state, action) {
      state.loqate.loqateEnabled = action.payload.loqateEnabled;
    },
    setSuggestedShippingAddress(state, action) {
      state.loqate.suggestedShippingAddress = action.payload.suggestedShippingAddress;
    },
    setSuggestedBillingAddress(state, action) {
      state.loqate.suggestedBillingAddress = action.payload.suggestedBillingAddress;
    },
    setShippingAddressType(state, action) {
      state.loqate.shippingAddressType = action.payload.addressType;
    },
    setBillingAddressType(state, action) {
      state.loqate.billingAddressType = action.payload.addressType;
    },
    setIsLoqateSuggestedAddress(state, action) {
      state.loqate.isLoqateSuggestedAddress = action.payload.isLoqateSuggestedAddress;
    },
    setBlockShippingLoqateAutocomplete(state, action) {
      state.loqate.blockShippingLoqateAutocomplete = action.payload.blockShippingLoqateAutocomplete;
    },
    setBlockBillingLoqateAutocomplete(state, action) {
      state.loqate.blockBillingLoqateAutocomplete = action.payload.blockBillingLoqateAutocomplete;
    },
    setShippingAQI(state, action) {
      state.loqate.shippingAQI = action.payload.shippingAQI;
    },
    setBillingAQI(state, action) {
      state.loqate.billingAQI = action.payload.billingAQI;
    },
    setFormattedShippingAddress(state, action) {
      state.loqate.formattedShippingAddress = action.payload.formattedShippingAddress;
    },
    setFormattedBillingAddress(state, action) {
      state.loqate.formattedBillingAddress = action.payload.formattedBillingAddress;
    },
    setShowShippingPopup(state, action) {
      state.loqate.showShippingPopup = action.payload.showShippingPopup;
    },
    setShowBillingPopup(state, action) {
      state.loqate.showBillingPopup = action.payload.showBillingPopup;
    },
    error(state,action){
      state.error = action.payload.error;
    },
    setLoginUserEditFormState(state, action){
      state.loginUserEditForm = action.payload.loginUserEditForm
    },
    setContactPreferencesState(state , action){
      state.contactPreference = action.payload.contactPreference;
    },
    setCartAddressAdded(state, action) {
      state.address.cartAddressAdded = action.payload.cartAddressAdded;
    },
    setBackToPreviousPage(state, action) {
      state.address.backToPreviousPage = action.payload.backToPreviousPage;
    },
    setLoqateInitialState(state, action) {
      state.loqate = {
          loqateEnabled : false,
          suggestedShippingAddress : {},
          suggestedBillingAddress : {},
          shippingAddressType: 'UNKNOWN',
          billingAddressType: 'UNKNOWN',
          isLoqateSuggestedAddress: false,
          formattedShippingAddress: {},
          formattedBillingAddress: {},
          showShippingPopup : false,
          showBillingPopup : false,
          blockShippingLoqateAutocomplete : false,
          blockBillingLoqateAutocomplete : false,
          shippingAQI : '',
          billingAQI : ''
      };
    },
    checkIsEmailChanged(state, action){
      state.contactPreference.isEmailChanged = action.payload.isEmailChanged
    }
    
};
export default reducers;
  